export var UserDocumentType;
(function (UserDocumentType) {
    /**
     * Insurance Document(s) uploaded by Office staff or patients
     * Displayed on the Patient Creation modal.
     */
    UserDocumentType["INSURANCE"] = "insurance";
})(UserDocumentType || (UserDocumentType = {}));
export var ProcedureDocumentType;
(function (ProcedureDocumentType) {
    /**
     * Document generated automatically for procedures when packer packs
     * CareSend box.
     */
    ProcedureDocumentType["INSTRUCTIONS"] = "instructions";
    /**
     * Document(s) uploaded by Office staff in Pro during a
     * procedure flow of type `labDraw`. Displayed on the Procedure Page in
     * Dashboard.
     */
    ProcedureDocumentType["REQUISITION_FORM"] = "requisitionForm";
    /**
     * Document generated automatically for procedures of the lab draw task (on
     * procedure creation, lab instructions change, and assignment to nurse)
     * Can also be manually uploaded by CareSend staff on Dashboard. Displayed to
     * the nurse during a patient visit.
     */
    ProcedureDocumentType["INSTRUCTIONAL_REQUISITION_FORM"] = "instructionalRequisitionForm";
    /** Not currently implemented */
    ProcedureDocumentType["LAB_INFO_FORM"] = "labInfoForm";
    /**
     * Document(s) uploaded by Office staff in Pro during a
     * procedure flow of type `generic`. Displayed on the Procedure Page in
     * Dashboard.
     */
    ProcedureDocumentType["GENERIC_DOCUMENTS"] = "genericDocuments";
})(ProcedureDocumentType || (ProcedureDocumentType = {}));
export var OrderDocumentType;
(function (OrderDocumentType) {
    /**
     * Document(s) uploaded by Office staff during Order Flow.
     * Will be viewable on dashboard.
     */
    OrderDocumentType["SUPPORTING_DOCUMENT"] = "supportingDocument";
})(OrderDocumentType || (OrderDocumentType = {}));
//# sourceMappingURL=document.js.map